// @flow

import Api from './ApiBase';

class RegionsApi extends Api {
  fetch = async () => {
    const json = await this.request('regions?page[limit]=100');
    const data = await this.deserialize(json);

    return { data };
  }
}

export default new RegionsApi();
